import graphqlClient from "../utils/graphql_client_util";
import { SessionStorageUtil } from "../utils/session_storage_util";
import { fetchAndStoreUser } from "./auth";

const MUTATIONS = {
  USE_COUPON: `
    mutation UseCoupon(
      $isUsed: CouponIsUsedType!
      $userSeq: Int!
      $serialNumber: String!
      $phoneNumber: String!
    ) {
      useCoupon(
        isUsed: $isUsed
        phoneNumber: $phoneNumber
        serialNumber: $serialNumber
        userSeq: $userSeq
      ) {
        success
        error {
          code
          errorType
          message
        }
        data {
          message
          success
        }
      }
    }
  `,
};

const QUERIES = {
  SEARCH_COUPONS_RECEIPT: `
    query SearchCouponsReceipt($input: CouponsReceiptSearchInput!) {
      searchCouponsReceipt(input: $input) {
        totalPages
        totalElements
        success
        size
        page
        error {
          code
          errorType
          message
        }
        data {
          userName
          couponsSeq
          couponProductsSeq
          couponType
          usedAt
          phoneNumber
          usedSub
          couponRegDate
          couponModDate
          isDeviceSerial
          couponStatus
          couponProductName
          couponProductType
          couponPrice
          durationValue
          durationUnit
          couponDetails
          couponIsActive
          couponUseLimitDate
          couponDesc
          couponName
          couponNumber
          couponProductTypeCodeDesc
          couponProductTypeCodeName
          userSeq
        }
      }
    }
  `,
};

/**
 * 내 쿠폰함 목록 조회
 * userSeq는 로그인 시 userBySeq로 채워진 SessionStorage 값 사용
 * @param {number} page - 페이지 (0-based)
 * @param {number} pageSize
 */
export const getCouponList = async (page = 0, pageSize = 12) => {
  try {
    const user = await fetchAndStoreUser();
    const userSeq = user?.userSeq ?? SessionStorageUtil.getItem("userSeq");

    const data = await graphqlClient.query(
      QUERIES.SEARCH_COUPONS_RECEIPT,
      {
        input: {
          userSeq,
          page,
          size: pageSize,
        },
      },
      { useAuth: true }
    );

    if (data.searchCouponsReceipt.success) {
      return {
        success: true,
        data: data.searchCouponsReceipt.data,
        totalPages: data.searchCouponsReceipt.totalPages,
        totalElements: data.searchCouponsReceipt.totalElements,
        page: data.searchCouponsReceipt.page,
      };
    } else {
      return {
        success: false,
        error: data.searchCouponsReceipt.error,
      };
    }
  } catch (err) {
    console.error(err);
    return {};
  }
};

/**
 * 쿠폰 등록 (사용 처리)
 * phoneNumber는 로그인 시 userBySeq로 채워진 SessionStorage 값 사용
 * @param {string} serialNumber - 16자리 쿠폰 번호
 * @param {string} isUsed - 'Y'(즉시 사용) | 'R'(등록만)
 */
export const registerCoupon = async (serialNumber, isUsed = "Y") => {
  try {
    // 항상 최신 유저 정보를 API에서 직접 조회
    const user = await fetchAndStoreUser();
    if (!user) {
      return {
        success: false,
        error: { message: "유저 정보를 불러올 수 없습니다." },
      };
    }

    const userSeq = parseInt(
      user.userSeq ?? SessionStorageUtil.getItem("userSeq"),
      10
    );
    const phoneNumber = user.userPhone || "";

    const data = await graphqlClient.mutation(
      MUTATIONS.USE_COUPON,
      {
        isUsed,
        userSeq,
        serialNumber,
        phoneNumber,
      },
      { useAuth: true }
    );

    if (data.useCoupon.success) {
      return { success: true, data: data.useCoupon.data };
    } else {
      return { success: false, error: data.useCoupon.error };
    }
  } catch (err) {
    console.error(err);
    return {};
  }
};
